import { render, staticRenderFns } from "./MemberComponent.vue?vue&type=template&id=520b5d76&scoped=true"
import script from "./MemberComponent.vue?vue&type=script&lang=js"
export * from "./MemberComponent.vue?vue&type=script&lang=js"
import style0 from "./MemberComponent.vue?vue&type=style&index=0&id=520b5d76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "520b5d76",
  null
  
)

export default component.exports